/* unplugin-vue-components disabled */import { render } from "./VideoSideModal.vue?vue&type=template&id=28c7a26e&scoped=true"
import script from "./VideoSideModal.vue?vue&type=script&lang=js"
export * from "./VideoSideModal.vue?vue&type=script&lang=js"

import "./VideoSideModal.vue?vue&type=style&index=0&id=28c7a26e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c7a26e"]])

export default __exports__